<div>
  <canvas id="proportionalSalesChart">{{proportionalSalesChart}}</canvas>
</div>
